import Navbar from "../components/Navbar";
import Landing from "../components/Landing";
import Button from "../components/Buttons";
import Badges from "../components/Badges";




function Home() {

  return (
    <div
      style={{
        minHeight: "100vh",
            width: "100vw",

        backgroundColor: "#fff",
        color:  "#000",
      }}
    >
      <Navbar  />
      <Landing />
      <Button /> 
      <Badges />  

    </div>
  );
}

export default Home;
